import PropTypes from 'prop-types'
import { useCallback, useEffect } from 'react'

const ScrollAnchor = ({ id, navTo, onModelChange, setLocalNavTo }) => {
  const onClearModel = useCallback(() => {
    onModelChange({
      navto: null,
      loading: false
    })
    setLocalNavTo(null)
  }, [onModelChange, setLocalNavTo])

  useEffect(() => {
    let timeoutId = null

    const cleanup = () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }

    if (!navTo) {
      return cleanup
    }

    const anchor = document.querySelector(`span[data-scroll="${id}-${navTo}"]`)

    if (!anchor) {
      onClearModel()
      return cleanup
    }

    const top = anchor.getBoundingClientRect().top + window.scrollY - 100

    timeoutId = setTimeout(() => {
      window.scrollTo({ top, behavior: 'smooth' })
      onClearModel()
    }, 300)

    return cleanup
  }, [onClearModel, id, navTo])

  return null
}

ScrollAnchor.propTypes = {
  id: PropTypes.string,
  navTo: PropTypes.string,
  onModelChange: PropTypes.func,
  setLocalNavTo: PropTypes.func
}

export default ScrollAnchor
